import axios from 'axios'
import security from '@/services/security.js'

const STAFF_DEVELOPMENT = 1
const COURSE_DAY = 2
// const OTHER = 3
export default {

  listStaffDevelopmentAgendas (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda/list/' + courseKey + '/' + STAFF_DEVELOPMENT, config)
      .then(response => {
        return response.data
      })
  },
  listCourseDayAgendas (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda/list/' + courseKey + '/' + COURSE_DAY, config)
      .then(response => {
        return response.data
      })
  },
  addNewAgenda (courseKey, agenda) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/agenda/' + courseKey, agenda, config)
      .then(response => {
        return response.data
      })
  },
  updateAgenda (courseKey, agenda) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/agenda/' + courseKey, agenda, config)
      .then(response => {
        return response.data
      })
  },
  deleteAgenda (courseKey, agendaId, agendaTypeId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/agenda/' + courseKey + '/' + agendaTypeId + '/' + agendaId, config)
      .then(response => {
        return response.data
      })
  },
  getNextAssignments (courseKey, scouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/agenda/' + courseKey + '/assignments/' + scouterKey, config)
      .then(response => {
        return response.data
      })
  }
}
